const columnChartConfigurationOptions = {
    // legend: { position: "top" },
    chartArea: { backgroundColor: "#dfdfdf" },
    vAxis: {
        gridlines: {
            color: "transparent",
        },
        baselineColor: "transparent",
    },
    hAxis: {
        gridlines: {
            color: "transparent",
        },
        baselineColor: "transparent",
    },
    animation: {
        duration: 1000,
        easing: "out",
        startup: true,
    },
};

const pieChartConfigurationOption = {
    pieHole: 0.4,
    is3D: true,
    slices: {
        0: { color: "#ed5027" },
        1: { color: "#fed93b" },
        2: { color: "#52a216" },
    },
    animation: {
        duration: 1000,
        easing: "out",
        startup: true,
    },
    // legend: { position: "bottom" },
};

export { columnChartConfigurationOptions, pieChartConfigurationOption };
